import giftService from './GiftService'

export default giftService
